import { makeAutoObservable, runInAction } from 'mobx'
import apiClient from '../utils/apiClient'
import logger from '../utils/logger'
import { registerTenantScopedReset } from '../tenancy/tenantScopedState'

class EntitlementStore {
	data = null
	status = 'idle'
	errorCode = null
	fetchPromise = null
	generation = 0

	constructor() {
		makeAutoObservable(this)
	}

	fetch({ force = false } = {}) {
		if (this.fetchPromise && !force) return this.fetchPromise
		const generation = this.generation
		const promise = this.fetchCurrent(generation)
		this.fetchPromise = promise
		const clearPromise = () => {
			runInAction(() => {
				if (this.fetchPromise === promise) this.fetchPromise = null
			})
		}
		promise.then(clearPromise, clearPromise)
		return promise
	}

	async fetchCurrent(generation) {
		runInAction(() => {
			this.status = 'loading'
			this.errorCode = null
		})
		try {
			const response = await apiClient.get('/api/entitlements/me')
			if (generation !== this.generation) return null
			runInAction(() => {
				this.data = response.data
				this.status = 'ready'
			})
			return response.data
		} catch (error) {
			if (generation !== this.generation) return null
			const errorCode = error.response?.data?.error?.code || 'ENTITLEMENTS_UNAVAILABLE'
			runInAction(() => {
				this.data = null
				this.status = 'error'
				this.errorCode = errorCode
			})
			logger.error('Entitlements bootstrap failed', { status: error.response?.status, errorCode })
			throw error
		}
	}

	clear() {
		this.generation += 1
		this.data = null
		this.status = 'idle'
		this.errorCode = null
		this.fetchPromise = null
	}
}

const entitlementStore = new EntitlementStore()
registerTenantScopedReset('entitlements', () => entitlementStore.clear())
export default entitlementStore
